import React from 'react';
import SignInView from './SignInView';
import SignUpView from './SignUpView';

const AuthView = ({
  email, setEmail, password, setPassword,
  setIsNewUser, isNewUser, setMessage, setIsAuthenticated
}) => {
  return (
    <div className="auth-view-container" id="authViewContainer">
      <div className="auth-brand-title" id="authBrandTitle" style={{ display: 'flex', justifyContent: 'center' }}>
        <img src="/Smack.png" alt="Smack Logo" style={{ height: '60px', width: 'auto' }} />
      </div>
      
      {setMessage && (
        <div className="auth-message-container" id="authMessageContainer">
          <p className="auth-error-message" id="authErrorMessage">{setMessage}</p>
        </div>
      )}
      
      {isNewUser ? (
        <div className="auth-signup-container" id="authSignupContainer">
          <SignUpView
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            setIsNewUser={setIsNewUser}
            setMessage={setMessage}
          />
        </div>
      ) : (
        <div className="auth-signin-container" id="authSigninContainer">
          <SignInView
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            setIsNewUser={setIsNewUser}
            setMessage={setMessage}
            setIsAuthenticated={setIsAuthenticated}
          />
        </div>
      )}
    </div>
  );
};

export default AuthView;